export default __webpack_public_path__ + "static/media/noe-display-bold-italic.88c38368.svg";